import { baseThunkConfig, createAppSlice } from '@exp/redux/createAppSlice';

import { getActiveCategories, putUserCategories } from '../api/profile';

const OTHER_CATEGORY_ID = 23;

/**
 * Category Slice
 */
const categorySlice = createAppSlice({
  initialState: {},
  name: 'category',
  reducers: (create) => ({
    fetchCategories: create.asyncThunk(() => getActiveCategories(), {
      ...baseThunkConfig,
      fulfilled: (state, action) => {
        // Omit the Other category from the options
        state.categories = action.payload.filter((item) => item.categoryId !== OTHER_CATEGORY_ID);
      },
    }),

    saveFavorites: create.asyncThunk(
      async (categories) => {
        await putUserCategories(categories || []);
        return categories || [];
      },
      {
        ...baseThunkConfig,
        fulfilled: (state, action) => {
          const favorites = action.payload.reduce(
            (map, c) => ({
              ...map,
              [c.categoryId]: c.order,
            }),
            {},
          );

          // Sync the new favorites with the categories
          state.categories = state.categories?.map((c) => ({
            ...c,
            favorite: favorites[c.categoryId] !== undefined,
            order: favorites[c.categoryId],
          }));
        },
      },
    ),
  }),
  selectors: {
    selectCategories: (state) => state.categories,
  },
});

export const { fetchCategories, saveFavorites } = categorySlice.actions;

export const { selectCategories } = categorySlice.selectors;

export default categorySlice;
